import { render, staticRenderFns } from "./CertificateCompletetion.vue?vue&type=template&id=b23b4b6c&"
import script from "./CertificateCompletetion.vue?vue&type=script&lang=ts&"
export * from "./CertificateCompletetion.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateCompletetion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports